/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechStorageUsbIcon20Solid = forwardRef('TechStorageUsbIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m15.918 9.201.114.114a1.5 1.5 0 0 1 0 2.121l-5.457 5.458a5.281 5.281 0 1 1-7.47-7.469l5.459-5.458a1.5 1.5 0 0 1 2.121 0l.114.115 2.409-2.409a1.5 1.5 0 0 1 2.121 0l2.998 2.998a1.5 1.5 0 0 1 0 2.121l-2.409 2.409ZM11.86 5.142l2.998 2.998 2.408-2.408-2.998-2.998-2.408 2.408Z" })));
});
